import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const CPP = () => {
  return (
    <StartInterviewLayout type="cpp"/>
  )
}

export default CPP;